import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import authService from "../services/authService";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap CSS আমদানি

const Header = () => {
  const navigate = useNavigate();
  const [role, setRole] = useState(null);

  useEffect(() => {
    try {
      const token = authService.getToken();
      if (token) {
        const currentUser = JSON.parse(token);

        setRole(currentUser.role === "user" ? "user" : "admin");
      } else {
        setRole(null);
      }
    } catch (error) {
      console.error("Error retrieving token:", error);
      setRole(null);
    }
  }, []);

  const handleLogout = () => {
    try {
      if (typeof authService.logout === "function") {
        authService.logout();
        navigate("/login");
      } else {
        console.error("authService.logout is not a function");
        localStorage.removeItem("token");
        localStorage.removeItem("apiKey");
        navigate("/login");
      }
    } catch (error) {
      console.error("Error during logout:", error);
      navigate("/login");
    }
  };

  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container">
        <Link className="navbar-brand" to="/">
          GameZone
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon">☰</span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {role === "admin" && (
              <>
                <li className="nav-item">
                  <Link className="nav-link" to="/admin">
                    Admin Dashboard
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/admin/categories">
                    Categories
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/admin/providers">
                    Providers
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/admin/games">
                    Games
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/admin/game-upload-new-version">
                    Game Upload (New)
                  </Link>
                </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/admin/project-names">
                      Project Names
                    </Link>
                  </li>
              </>
            )}
          </ul>
          <ul className="navbar-nav ms-auto">
            {role ? (
              <li className="nav-item">
                <button
                  className="nav-link btn btn-logout"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </li>
            ) : (
              <>
                <li className="nav-item">
                  <Link className="nav-link btn btn-login" to="/login">
                    Login
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link btn btn-login" to="/signup">
                    Sign Up
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
